enum LocalStorageKey {
  VERSION_UPDATED = 'versionUpdated',
  SHOULD_USE_NEW_EMPLOYER_ONBOARDING = 'shouldUseNewEmployerOnboarding',
}

export default LocalStorageKey;
